import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Form
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { func } from "prop-types";
import Switch from '@material-ui/core/Switch';

// Bodegas que se consideran "de plataforma" (marketplaces). El resto = propias.
const PLATAFORMA_BODEGAS = [
  "Amazon 1 FBA",
  "Amazon 2 FBA",
  "Bodega Coppel",
  "Mercado Libre Bisulinc FULL",
  "Mercado Libre Shopilinc FULL",
  "Mercado Libre Buken FULL",
];
const _norm = (s) => String(s || "").trim().toLowerCase();
const _SET_PLATAFORMA = new Set(PLATAFORMA_BODEGAS.map(_norm));
const fmtMoney = (v) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(Number(v) || 0);
const fmtNum = (v) => new Intl.NumberFormat("en-US").format(Number(v) || 0);

function ListadoInventariosCostos() {
  const { user } = useContext(AuthContext);
  const URL_INVENTARIOS = `${process.env.REACT_APP_URL_INVENTARIOS}`;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [lineas, setLineas] = useState([]);
  const [selectedLineaFiltro, setSelectedLineaFiltro] = useState("");
  const [selectedLineaCompacta, setSelectedLineaCompacta] = useState("");
  const [searchCompacta, setSearchCompacta] = useState("");
  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");
  const [familias, setFamilias] = useState([]);
  const [selectedFamiliaFiltro, setSelectedFamiliaFiltro] = useState("");
  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

  const [mayorQue, setMayorQue] = useState(0);
  const [menorQue, setMenorQue] = useState(10000000);
  
  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");

  const [text, setText] = useState(false);
  const [idArticulo, setIdArticulo] = useState("");
  const [SKU, setSKU] = useState("");
  const [costoMX, setCostoMX] = useState("");
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [activo, setActivo] = useState("");

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const [idEditArticulo, setIdEditArticulo] = useState("");
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;
  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);

  const [totalTotal, setTotalTotal] = useState(0);
  const [totalTotalDinero, setTotalTotalDinero] = useState(0);
  const [totalTotalCajas, setTotalTotalCajas] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [comments2, setComments2] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  // Paginacion/orden propios de la tabla compacta "Detalle de Inventario"
  const [currentPageCompacta, setCurrentPageCompacta] = useState(1);
  const [sortingCompacta, setSortingCompacta] = useState({ field: "", order: "" });

  // Filtro por almacen (uno o varios) para la vista agrupada
  const [selectedAlmacenes, setSelectedAlmacenes] = useState([]);
  const toggleAlmacen = (id) => {
    setSelectedAlmacenes((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
    setCurrentPageCompacta(1);
  };

  const ITEMS_PER_PAGE = 50;

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(12), (val, index) => index + year);

  useEffect(() => {
    axios
      .get(`${URL_INVENTARIOS}Acumulado`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInventarios = response.data;
        // Array para pagination
        let arrayTabla = allInventarios
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            // if(a.cantidad >0){
            return {
              _id: a._id,
              idArticulo: a.idArticulo,
              activo: a.activo,
              cantidad: a.cantidad,
              codigo: a.codigo,
              SKU: a.SKU,
              ASIN: a.ASIN,
              nombre: a.nombre,
              idArticulo: a.idArticulo,
              costoUSD: a.costoUSD,
              costoMX: a.costoMX,
              masterCosto: a.masterCosto,
              totalDinero: a.totalDinero,
              venta: a.venta,
              observaciones: a.observaciones,
              idCompras: a.idCompras,
              piezasPorCaja: a.piezasPorCaja,
              lote: a.lote,
              linea: a.linea,
              idLinea: a.idLinea,
              marca: a.marca,
              idMarca: a.idMarca,
              familia: a.familia,
              idFamilia: a.idFamilia,
              unidadNegocio: a.unidadNegocio,
              idUnidadNegocio: a.idUnidadNegocio,
              proveedor: a.proveedor,
              idProveedor: a.idProveedor,
              cajas: (a.cantidad / a.piezasPorCaja).toFixed(2),
              area: a.area,
              idArea: a.idArea,
              modelo: a.modelo,
              porcentajeGastos: a.porcentajeGastos,
              costoTotal: a.costoMX +(a.costoMX * (a.porcentajeGastos / 100))
            }

        // }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);

        let unicosMar = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idMarca === value.idMarca)
        );
        setMarcas(unicosMar);
  
        let unicosUni = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idUnidadNegocio === value.idUnidadNegocio)
        );
        setUnidadesNegocio(unicosUni);
  
        let unicosFam = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idFamilia === value.idFamilia)
        );
        setFamilias(unicosFam);
  
        let unicosLinea = dataFinal.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.idLinea === value.idLinea)
        );
        setLineas(unicosLinea);
      
      })
      .catch((err) => {
        console.log(err);
      });


    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);


  function PDFTabla() {
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 12, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 12, 45, 15);
    doc.setFontSize(13);
    doc.text(`Inventario General: ${fmtMoney(resumenInv.general)}`, 14, 38);
    doc.autoTable({
      head: [["Categoria", "Valor de Inventario"]],
      body: resumenInv.porLinea.map((l) => [l.linea, fmtMoney(l.valor)]),
      startY: 42,
      styles: { fontSize: 8 },
    });
    doc.autoTable({
      head: [["ITEM", "Nombre", "Bodegas propias", "Bodegas plataforma", "Costo", "Valor de Inventario", "% de inventario"]],
      body: detalleFiltrado.map((a) => [
        a.item,
        a.nombre,
        fmtNum(a.propias),
        fmtNum(a.plataforma),
        fmtMoney(a.costo),
        fmtMoney(a.valor),
        `${a.pct.toFixed(1)}%`,
      ]),
      startY: doc.lastAutoTable.finalY + 8,
      styles: { fontSize: 7 },
    });
    doc.save(`InventariosCostos.pdf`);
  }

  function excel() {
    var option = {};
    option.fileName = "ListadoInventariosCostos";
    option.datas = [
      {
        sheetData: detalleFiltrado.map((a) => ({
          Item: a.item,
          Nombre: a.nombre,
          BodegasPropias: a.propias,
          BodegasPlataforma: a.plataforma,
          Costo: Number((a.costo || 0).toFixed(2)),
          ValorInventario: Number((a.valor || 0).toFixed(2)),
          PctInventario: Number((a.pct || 0).toFixed(2)),
        })),
        sheetName: "Detalle",
        sheetFilter: ["Item", "Nombre", "BodegasPropias", "BodegasPlataforma", "Costo", "ValorInventario", "PctInventario"],
        sheetHeader: ["Item", "Nombre", "Bodegas propias", "Bodegas plataforma", "Costo", "Valor de Inventario", "% de inventario"],
      },
      {
        sheetData: resumenInv.porLinea.map((l) => ({
          Categoria: l.linea,
          ValorInventario: Number((l.valor || 0).toFixed(2)),
        })),
        sheetName: "Por Categoria",
        sheetFilter: ["Categoria", "ValorInventario"],
        sheetHeader: ["Categoria", "Valor de Inventario"],
      },
    ];
    new ExportJsonExcel(option).saveExcel();
  }

  function enviaMail() {
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 12, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 12, 45, 15);
    doc.setFontSize(13);
    doc.text(`Inventario General: ${fmtMoney(resumenInv.general)}`, 14, 38);
    doc.autoTable({
      head: [["Categoria", "Valor de Inventario"]],
      body: resumenInv.porLinea.map((l) => [l.linea, fmtMoney(l.valor)]),
      startY: 42,
      styles: { fontSize: 8 },
    });
    doc.autoTable({
      head: [["ITEM", "Nombre", "Bodegas propias", "Bodegas plataforma", "Costo", "Valor de Inventario", "% de inventario"]],
      body: detalleFiltrado.map((a) => [
        a.item,
        a.nombre,
        fmtNum(a.propias),
        fmtNum(a.plataforma),
        fmtMoney(a.costo),
        fmtMoney(a.valor),
        `${a.pct.toFixed(1)}%`,
      ]),
      startY: doc.lastAutoTable.finalY + 8,
      styles: { fontSize: 7 },
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Inventarios Costos",
          email: mailTo,
          fileName: "ListadoInventariosCostos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Inventarios Costos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

 

  const headers = [
    { name: "SKU", field: "SKU", sortable: true },
    { name: "ASIN", field: "ASIN", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Categoria", field: "linea", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    // { name: "Familia", field: "familia", sortable: true },
    { name: "UnidadNegocio", field: "unidadNegocio", sortable: true },
    // { name: "Venta", field: "venta", sortable: true },
    { name: "Pzas. Caja", field: "piezasPorCaja", sortable: true },
    { name: "Cajas", field: "cajas", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Costo Unitario", field: "costoMX", sortable: true },
    { name: "% Gastos", field: "porcentajeGastos", sortable: true },
    { name: "Total Costo", field: "costoTotal", sortable: true },
    { name: "Total Dinero", field: "totalDinero", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Ficha Tecnica", field: "foto", sortable: false },
  ];

  // Vista compacta tipo "Reporte de Inventario": general, por linea y detalle
  // con split bodegas propias vs bodegas de plataforma (marketplaces).
  const resumenInv = useMemo(() => {
    // Filtro por almacen (uno o varios); vacio = todos
    let filas = comments;
    if (selectedAlmacenes.length > 0) {
      filas = comments.filter((r) => selectedAlmacenes.includes(String(r.idArea)));
    }
    const porArt = {};
    filas.forEach((r) => {
      const id = r.idArticulo;
      // Costo = ultimo MasterCostos > 0; si no hay, el costoMX del catalogo
      const costoArt =
        Number(r.masterCosto) > 0 ? Number(r.masterCosto) : Number(r.costoMX) || 0;
      if (!porArt[id]) {
        porArt[id] = {
          idArticulo: id,
          item: r.SKU || r.codigo || "",
          nombre: r.nombre || "",
          linea: r.linea || "Sin linea",
          idLinea: r.idLinea || "0",
          costo: costoArt,
          propias: 0,
          plataforma: 0,
        };
      }
      const cant = Number(r.cantidad) || 0;
      if (_SET_PLATAFORMA.has(_norm(r.area))) porArt[id].plataforma += cant;
      else porArt[id].propias += cant;
      if (costoArt) porArt[id].costo = costoArt;
    });

    let detalle = Object.values(porArt).map((a) => {
      const total = a.propias + a.plataforma;
      return { ...a, total, valor: a.costo * total };
    });
    detalle = detalle.filter((a) => a.total !== 0);

    const general = detalle.reduce((t, a) => t + a.valor, 0);
    detalle.forEach((a) => (a.pct = general > 0 ? (a.valor / general) * 100 : 0));
    detalle.sort((x, y) => y.valor - x.valor);

    const lineaMap = {};
    detalle.forEach((a) => {
      const k = a.idLinea || a.linea;
      if (!lineaMap[k]) lineaMap[k] = { linea: a.linea, valor: 0 };
      lineaMap[k].valor += a.valor;
    });
    const porLinea = Object.values(lineaMap).sort((x, y) => y.valor - x.valor);

    return { general, porLinea, detalle };
  }, [comments, selectedAlmacenes]);

  // Lista de almacenes (areas) disponibles en el inventario
  const almacenes = useMemo(() => {
    const map = {};
    comments.forEach((r) => {
      if (r.idArea && !map[r.idArea]) map[r.idArea] = r.area || "Sin almacen";
    });
    return Object.entries(map)
      .map(([idArea, area]) => ({ idArea, area }))
      .sort((a, b) => (a.area > b.area ? 1 : -1));
  }, [comments]);

  // Detalle filtrado por linea y busqueda (solo afecta la tabla de detalle)
  const detalleFiltrado = useMemo(() => {
    let lista = resumenInv.detalle;
    if (selectedLineaCompacta) {
      lista = lista.filter((a) => String(a.idLinea) === String(selectedLineaCompacta));
    }
    if (searchCompacta) {
      const s = searchCompacta.toLowerCase();
      lista = lista.filter(
        (a) =>
          String(a.item || "").toLowerCase().includes(s) ||
          String(a.nombre || "").toLowerCase().includes(s)
      );
    }
    return lista;
  }, [resumenInv, selectedLineaCompacta, searchCompacta]);

  // Headers y paginacion estandar para "Detalle de Inventario"
  const headersCompacta = [
    { name: "ITEM", field: "item", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Inventario de bodegas propias", field: "propias", sortable: true },
    { name: "Bodegas de plataforma", field: "plataforma", sortable: true },
    { name: "Costo", field: "costo", sortable: true },
    { name: "Valor de Inventario", field: "valor", sortable: true },
    { name: "% de inventario", field: "pct", sortable: true },
  ];

  const detallePaginado = useMemo(() => {
    let computed = [...detalleFiltrado];
    const numFields = ["propias", "plataforma", "costo", "valor", "pct"];
    if (sortingCompacta.field) {
      const reversed = sortingCompacta.order === "asc" ? 1 : -1;
      if (numFields.includes(sortingCompacta.field)) {
        computed.sort(
          (a, b) =>
            reversed * (parseFloat(a[sortingCompacta.field]) - parseFloat(b[sortingCompacta.field]))
        );
      } else {
        computed.sort(
          (a, b) =>
            reversed *
            String(a[sortingCompacta.field] || "").localeCompare(String(b[sortingCompacta.field] || ""))
        );
      }
    }
    return computed.slice(
      (currentPageCompacta - 1) * ITEMS_PER_PAGE,
      (currentPageCompacta - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [detalleFiltrado, sortingCompacta, currentPageCompacta]);

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.SKU.toLowerCase().includes(search.toLowerCase()) ||
        comment.ASIN.toLowerCase().includes(search.toLowerCase()) ||
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.linea.toLowerCase().includes(search.toLowerCase()) ||
          comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          // comment.familia.toLowerCase().includes(search.toLowerCase()) ||
          comment.unidadNegocio.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.cajas.toString().includes(search)||
          comment.cantidad.toString().includes(search)||
          comment.costoMX.toString().includes(search)||
          comment.totalDinero.toString().includes(search)||
          comment.porcentajeGastos.toString().includes(search)||
          comment.costoTotal.toString().includes(search)||
          // comment.venta.toString().includes(search)||
          comment.piezasPorCaja.toString().includes(search)
      );
    }

    // if (selectedLineaFiltro) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idLinea.includes(selectedLineaFiltro)
    //   );
    // }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }
    // if (selectedMarca) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idMarca.includes(selectedMarca)
    //   );
    // }
    if (selectedArticulo) {
      computedComments = computedComments.filter((e) =>
        e.idArticulo.includes(selectedArticulo)
      );
    }
    // if (selectedFamiliaFiltro) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idFamilia.includes(selectedFamiliaFiltro)
    //   );
    // }
    // if (selectedUnidadNegocio) {
    //   computedComments = computedComments.filter((e) =>
    //     e.idUnidadNegocio.includes(selectedUnidadNegocio)
    //   );
    // }
    if (selectedArea) {
      computedComments = computedComments.filter((e) =>
        e.idArea.includes(selectedArea)
      );
    }


    if (mayorQue) {
      computedComments = computedComments.filter(
        (e) => e.cantidad >= mayorQue
      );
    }

    if (menorQue) {
      computedComments = computedComments.filter(
        (e) => e.cantidad <= menorQue
      );
    }


    if(selectedUnidadNegocio.length > 0){
      if (selectedUnidadNegocio) {
        computedComments = computedComments.filter((e) =>
          selectedUnidadNegocio.some((a) => e.idUnidadNegocio && e.idUnidadNegocio.includes(a))
        );
      }
    }
    
    
    if(selectedMarca.length > 0){
      if (selectedMarca) {
        computedComments = computedComments.filter((e) =>
          selectedMarca.some((a) => e.idMarca && e.idMarca.includes(a))
        );
      }
    }
    
    
    if(selectedLineaFiltro.length > 0){
      if (selectedLineaFiltro) {
        computedComments = computedComments.filter((e) =>
          selectedLineaFiltro.some((a) => e.idLinea && e.idLinea.includes(a))
        );
      }
    }

    let can = computedComments.map((c) => parseFloat(c.cantidad));
    let TCan = can.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotal(TCan);

    let din = computedComments.map((c) => parseFloat(c.totalDinero));
    let TDin = din.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalDinero(TDin);

    let caj = computedComments.map((c) => parseFloat(c.cajas));
    let Tcaj = caj.reduce((t, cajas, index) => t + cajas, 0);
    setTotalTotalCajas(Tcaj);

    setTotalItems(computedComments.length);

    setComments2(computedComments)

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "costoMX" &&
      sorting.field != "totalDinero" &&
      sorting.field != "costoTotal" &&
      sorting.field != "porcentajeGastos" &&
      sorting.field != "piezasPorCaja" &&
      sorting.field != "cajas" &&
      sorting.field != "venta"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "costoMX" ||
        sorting.field == "totalDinero" ||
        sorting.field == "costoTotal" ||
        sorting.field == "porcentajeGastos" ||
        sorting.field == "piezasPorCaja" ||
        sorting.field == "cajas" ||
        sorting.field == "venta")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "costoMX" ||
        sorting.field == "totalDinero" ||
        sorting.field == "costoTotal" ||
        sorting.field == "porcentajeGastos" ||
        sorting.field == "piezasPorCaja" ||
        sorting.field == "cajas" ||
        sorting.field == "venta")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedArticulo,
    activo,
    selectedLineaFiltro,
    selectedMarca, 
    // selectedFamiliaFiltro, 
    selectedUnidadNegocio,
    selectedArea,
    mayorQue,
    menorQue
  ]);


  function limpiarSearch(){
    setSearch("")
    setSelectedArticulo("")
    setSelectedLineaFiltro("")
    setSelectedMarca("")
    setSelectedFamiliaFiltro("")
    setSelectedUnidadNegocio("")
    setSelectedArea("")
  }

  
  function jalaFoto(
    idEdit
  ) {
    setPhoto("")
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${idEdit}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.version) {
          setPhoto(data.data.version);
        }
      })
      .catch((err) => console.log(err));


    setIdEditArticulo(idEdit);
    toggleFoto();
  }

  const handleCheckboxChangeUnidadNegocio = (e) => {
    const { value, checked } = e.target;
    // Actualiza el estado de los artículos seleccionados
    if (checked) {
      setSelectedUnidadNegocio([...selectedUnidadNegocio, value]);
    } else {
      setSelectedUnidadNegocio(selectedUnidadNegocio.filter(item => item !== value));
    }
  };

  const handleCheckboxChangeMarca = (e) => {
    const { value, checked } = e.target;
    // Actualiza el estado de los artículos seleccionados
    if (checked) {
      setSelectedMarca([...selectedMarca, value]);
    } else {
      setSelectedMarca(selectedMarca.filter(item => item !== value));
    }
  };

  const handleCheckboxChangeLinea = (e) => {
    const { value, checked } = e.target;
    // Actualiza el estado de los artículos seleccionados
    if (checked) {
      setSelectedLineaFiltro([...selectedLineaFiltro, value]);
    } else {
      setSelectedLineaFiltro(selectedLineaFiltro.filter(item => item !== value));
    }
  };

  function EditCostoMX(
    idArticulo,
    SKU,
    costoMX
  ) {
    setIdArticulo(idArticulo)
    setSKU(SKU)
    setCostoMX(costoMX)
    toggleEdit();
  }

  const EditCostoMXSave = (event) => {
    event.preventDefault();
    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará el Costo MX",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ARTICULOS}EditarCostoMX/${idArticulo}`,
            {
              costoMX
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Costo Articulo",
                detalle: `${SKU}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      }
    });
  };

  let total = 0;
  let total_cajas = 0;
  return (
    <>
      <Header />
      <br />
      <br />
      {user.inventarios_costos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/ReportesBI"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
              
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Inventarios Costos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
         
          <h3 align="center">Inventarios Costos</h3>

          {/* ====== Vista compacta tipo "Reporte de Inventario" ====== */}
          <div style={{ border: "1px solid #ccc", borderRadius: "6px", padding: "12px", marginBottom: "16px" }}>
            {/* Filtro por almacen (uno o varios) */}
            <div style={{ marginBottom: "10px" }}>
              <span className="negrita" style={{ marginRight: 12 }}>
                Almacenes:{" "}
                {selectedAlmacenes.length > 0 && (
                  <small
                    style={{ color: "#1565c0", cursor: "pointer" }}
                    onClick={() => {
                      setSelectedAlmacenes([]);
                      setCurrentPageCompacta(1);
                    }}
                  >
                    (todos)
                  </small>
                )}
              </span>
              {almacenes.map((al) => (
                <label
                  key={al.idArea}
                  style={{ marginRight: 18, fontWeight: "normal", cursor: "pointer", whiteSpace: "nowrap", display: "inline-block" }}
                >
                  <input
                    type="checkbox"
                    checked={selectedAlmacenes.includes(al.idArea)}
                    onChange={() => toggleAlmacen(al.idArea)}
                    style={{ marginRight: 5, verticalAlign: "middle" }}
                  />
                  <span style={{ verticalAlign: "middle" }}>{al.area}</span>
                </label>
              ))}
            </div>

            <Row className="align-items-center" style={{ marginBottom: "10px" }}>
              <Col md={6}>
                <h3 className="negrita" style={{ margin: 0 }}>Inventario General</h3>
              </Col>
              <Col md={6} className="text-right">
                <h3 className="negrita" style={{ margin: 0 }}>{fmtMoney(resumenInv.general)}</h3>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Table size="sm" bordered className="table-responsive-xl">
                  <thead className="thead-light">
                    <tr>
                      <th>Categoria</th>
                      <th className="text-right">Valor de Inventario</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resumenInv.porLinea.map((l) => (
                      <tr key={l.linea}>
                        <td className="negrita">{l.linea}</td>
                        <td className="text-right">{fmtMoney(l.valor)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            </Row>

            <h3 align="center">Detalle de Inventario</h3>
            <div className="row">
              <div className="col-md-8">
                <Pagination
                  total={detalleFiltrado.length}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPageCompacta}
                  onPageChange={(page) => setCurrentPageCompacta(page)}
                />
              </div>
              <div className="col-md-4 d-flex flex-row-reverse">
                <Search
                  onSearch={(value) => {
                    setSearchCompacta(value);
                    setCurrentPageCompacta(1);
                  }}
                />
              </div>
            </div>
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Categoria</Label>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedLineaCompacta}
                  onChange={(e) => {
                    setSelectedLineaCompacta(e.target.value);
                    setCurrentPageCompacta(1);
                  }}
                >
                  <option value="">Todas</option>
                  {resumenInv.porLinea
                    .map((l) => {
                      const found = resumenInv.detalle.find((d) => d.linea === l.linea);
                      return found ? { linea: l.linea, idLinea: found.idLinea } : null;
                    })
                    .filter(Boolean)
                    .sort((a, b) => (a.linea > b.linea ? 1 : -1))
                    .map((l) => (
                      <option key={l.idLinea} value={l.idLinea}>
                        {l.linea}
                      </option>
                    ))}
                </Input>
              </Col>
            </Row>
            <br />
            <Table size="sm" striped borderless className="table-responsive-xl">
              <TableHeader
                headers={headersCompacta}
                onSorting={(field, order) => setSortingCompacta({ field, order })}
              />
              <tbody>
                {detallePaginado.map((a) => (
                  <tr key={a.idArticulo}>
                    <td>{a.item}</td>
                    <td>{a.nombre}</td>
                    <td>{fmtNum(a.propias)}</td>
                    <td>{fmtNum(a.plataforma)}</td>
                    <td>{fmtMoney(a.costo)}</td>
                    <td>{fmtMoney(a.valor)}</td>
                    <td>{a.pct.toFixed(1)}%</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="col-md-6">
              <Pagination
                total={detalleFiltrado.length}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPageCompacta}
                onPageChange={(page) => setCurrentPageCompacta(page)}
              />
            </div>
          </div>
          {/* ====== fin vista compacta ====== */}

        </div>
      ) : undefined}
  <Modal size="sm" isOpen={modalFoto} toggle={toggleFoto}>
        <ModalHeader toggle={toggleFoto}>
          <h4>
            Ficha Tecnica
          </h4>
        </ModalHeader>
        <ModalBody>
        <Row>
            {photo ? (
              <h6 style={{ textAlign: "center" }}>
                <img
                  // loading="lazy"
                  src={`${process.env.REACT_APP_URL_FOTO_CLOUDINARY}/image/upload/v${photo}/shopilincArticulos/${idEditArticulo}.jpg`}
                  alt=""
                />
              </h6>
            ) : <h4>No se ha subido una Ficha Tecnica....</h4>}
          </Row>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalEdit} toggle={toggleEdit}>
            <ModalHeader toggle={toggleEdit}>
              <h4>Editar Costo del Articulo {SKU}</h4>
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={EditCostoMXSave}>
                {/* <Row>
                  <Col md={6}>
                    <Label>Fecha</Label>
                    <Input
                      type="date"
                      value={fechaEdit}
                      required
                      disabled
                    />
                  </Col>
                </Row> */}
                <Row>
                  <Col md={12}>
                    <Label>Costo MX</Label>
                    <Input
                      className="col-sm-12"
                      type="number"
                      placeholder="CostoMX"
                      value={costoMX}
                      required
                      onChange={(e) => {
                        setCostoMX(e.target.value);
                      }}
                    />
                  </Col>
                </Row>

                <br />
                <Row>
                    <Button type="submit" className="btn btn-success">
                      Guardar
                    </Button>

                  <div>
                    <SweetAlert
                      show={text}
                      title="Guardado con Exito"
                      onConfirm={() => {
                        setText(false);
                      }}
                    />
                  </div>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
     
      {loader}
    </>
  );
}

export default ListadoInventariosCostos;
